import {
  GetFacilitiesParams,
  getFacilities as getFacilitiesCall
} from '~/helpers/orchestration/facilities';
import { Facility } from '../interfaces/Facility';
import { ReduxDispatch } from '../interfaces/Redux';

const getFacilitiesRequest = () => ({
  type: 'GET_FACILITIES_REQUEST' as const
});

const getFacilitiesSuccess = (payload: Facility[]) => ({
  type: 'GET_FACILITIES_SUCCESS' as const,
  payload
});

const getFacilitiesFailure = (payload: unknown) => ({
  type: 'GET_FACILITIES_FAILURE' as const,
  payload
});

export type GetFacilitiesAction =
  | ReturnType<typeof getFacilitiesRequest>
  | ReturnType<typeof getFacilitiesSuccess>
  | ReturnType<typeof getFacilitiesFailure>;

export const getFacilities =
  (params?: GetFacilitiesParams) => (dispatch: ReduxDispatch) => {
    dispatch(getFacilitiesRequest());

    getFacilitiesCall({
      params: { facilityService: 'DELIVERY', ...params?.params }
    })
      .then(response => {
        dispatch(getFacilitiesSuccess(response));
      })
      .catch((err: unknown) => {
        dispatch(getFacilitiesFailure(err));
      });
  };

const getCheckoutFacilitiesRequest = () => ({
  type: 'GET_CHECKOUT_FACILITIES_REQUEST' as const
});

const getCheckoutFacilitiesSuccess = (payload: Facility[]) => ({
  type: 'GET_CHECKOUT_FACILITIES_SUCCESS' as const,
  payload
});

const getCheckoutFacilitiesFailure = (payload: unknown) => ({
  type: 'GET_CHECKOUT_FACILITIES_FAILURE' as const,
  payload
});

export type GetCheckoutFacilitiesAction =
  | ReturnType<typeof getCheckoutFacilitiesRequest>
  | ReturnType<typeof getCheckoutFacilitiesSuccess>
  | ReturnType<typeof getCheckoutFacilitiesFailure>;

export const getCheckoutFacilities =
  (params?: GetFacilitiesParams) => (dispatch: ReduxDispatch) => {
    dispatch(getCheckoutFacilitiesRequest());

    getFacilitiesCall({
      params: { facilityService: 'DELIVERY', ...params?.params }
    })
      .then(response => {
        dispatch(getCheckoutFacilitiesSuccess(response));
      })
      .catch((err: unknown) => {
        dispatch(getCheckoutFacilitiesFailure(err));
      });
  };
